/**
 * Toggle class on target element when trigger element is clicked
 * 
 * @return void
 */
export const toggleText = () => {
    const triggerElements = document.querySelectorAll('.live-stream__more-info');

    if (!triggerElements.length) {
        return () => {}; // Return empty cleanup function if elements don't exist
    }

    const handleClick = (event) => {
        event.preventDefault();

        const triggerElement = event.currentTarget;
        // Find the closest parent container and then find the description element within it
        const parentContainer = triggerElement.closest('.live-stream');
        const targetElement = parentContainer ? parentContainer.querySelector('.live-stream__description') : null;

        if (targetElement) {
            targetElement.classList.toggle('live-stream__description--show-all');
        }
    };

    // Add click event listeners to all trigger elements
    triggerElements.forEach(element => {
        element.addEventListener('click', handleClick);
    });
};

export default toggleText;
